<div class="control__wrapper bg-light"
     *ngIf="canvas.canvasJSLoaded">
    <div [ngClass]="{ 'control__shadow': control.elementVal.getValue()?.duringChange === 't' }"></div>
    <img class="control__img bg-style border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />
    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>
    <div class="control__content">
        <div id="chartContainer" class="chart-container"></div>
    </div>
    <div class="heating-shift__group-btn">
        <div class="heating-shift__slope color-basic">
            <p class="heating-shift__name">{{ subtitle(2500) }}</p>
            <div class="heating-shift__btn color-basic cursor-pointer"
                data-testid="decreaseSlope">
                <hold-wrapper (onAction)="heatingCurve.changeChart(0,-1)">
                    <img class="heating-shift__arrow-img"
                        ngSrc="/assets/img/icons/minus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="heating-shift__value heating-shift__slope-btn font-28 font-bold"
                [ngClass]="{ 'color-inactive': control.elementVal.getValue()?.duringChange === 't',
                    'color-style': control.elementVal.getValue()?.duringChange == 'f' }"
                data-testid="slopeValue">
                {{ (heatingCurve.slope / 10).toFixed(1) }}
            </div>
            <div class="heating-shift__btn color-basic cursor-pointer"
                data-testid="increaseSlope">
                <hold-wrapper (onAction)="heatingCurve.changeChart(0,1)">
                    <img class="heating-shift__arrow-img"
                        ngSrc="/assets/img/icons/plus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
        <div class="heating-shift__shift color-basic">
            <p class="heating-shift__name">{{ subtitle(2499) }}</p>
            <div class="heating-shift__btn color-basic cursor-pointer"
                data-testid="decreaseOffset">
                <hold-wrapper (onAction)="heatingCurve.changeChart(-1,0)">
                    <img class="heating-shift__arrow-img"
                        ngSrc="/assets/img/icons/minus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
            <div class="heating-shift__value heating-shift__shift-btn font-28 font-bold"
                [ngClass]="{ 'color-inactive': control.elementVal.getValue()?.duringChange === 't',
                    'color-style': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="offsetValue">
                {{ heatingCurve.shift }}
            </div>
            <div class="heating-shift__btn color-basic cursor-pointer"
                data-testid="increaseOffset">
                <hold-wrapper (onAction)="heatingCurve.changeChart(1,0)">
                    <img class="heating-shift__arrow-img"
                        ngSrc="/assets/img/icons/plus.svg"
                        width="40" height="40" alt="" />
                </hold-wrapper>
            </div>
        </div>
    </div>
    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                ngSrc="/assets/img/zone_icons/back.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="heatingCurve.createHeatingCurveChart()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange === 'f' }"
                data-testid="sendButton"
                (click)="heatingCurve.returnHeatingCurveChart()">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/ok.svg"
                width="40" height="40" alt="" />
        </button>
    </div>
    <div *ngIf="control.elementVal.getValue()?.duringChange === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
